export default __webpack_public_path__ + "static/media/imaging-result-checklist.cd94216b.png";